import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "m3.253 3.367 28.434 17.77c-.135.99-.317 1.99-.554 2.987 0 0-.514 2.458-2.387 4.51L.313 10.861c.134-.989.316-1.99.553-2.987 0 0 .514-2.457 2.387-4.508",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#000",
      fillRule: "evenodd",
      d: "m1.212 6.758 29.576 18.484c-.34.904-.967 2.215-2.042 3.391L.313 10.863c.134-.99.316-1.99.553-2.988 0 0 .094-.446.346-1.117",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      d: "M18.256 21.41c.153-.082-.284.422.3.59.585.168 1.13-.967 2.051-.447.184-.148-.051-.437-.374-.458.132-.278.112-.4.08-.448-.316-.45-1.08.1-1.012.043a.467.467 0 1 0-.602-.714c-.87.734-1.766 1.092-2.698 1.09-.936.002-1.831-.356-2.702-1.09a.467.467 0 0 0-.601.714c.066.056-.697-.493-1.012-.043-.033.048-.053.17.08.448-.323.021-.559.31-.375.458.922-.52 1.466.615 2.051.447s.147-.672.3-.59Q14.829 22 16 22a4.66 4.66 0 0 0 2.257-.59"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M20.667 16.186a.5.5 0 0 1 .122-.327l.528-.612a.5.5 0 0 0 .07-.106l.242-.492a.5.5 0 0 1 .351-.27l.402-.08a.2.2 0 0 1 .236.234l-.184.979a.5.5 0 0 1-.105.225l-.548.666a.5.5 0 0 0-.114.317v1.517c0 .08.02.16.056.231l.192.367a.18.18 0 0 1-.079.251 1.7 1.7 0 0 1-.67.172 1.7 1.7 0 0 1-.668-.172.18.18 0 0 1-.079-.25l.191-.368a.5.5 0 0 0 .057-.23zm-9.327 0a.5.5 0 0 0-.122-.327l-.529-.612a.5.5 0 0 1-.07-.106l-.242-.492a.5.5 0 0 0-.35-.27l-.403-.08a.2.2 0 0 0-.236.234l.184.979a.5.5 0 0 0 .106.225l.547.666a.5.5 0 0 1 .114.317v1.517a.5.5 0 0 1-.056.231l-.191.367c-.049.093-.017.207.078.251.16.075.415.172.67.172.254 0 .51-.097.669-.172a.18.18 0 0 0 .078-.25l-.191-.368a.5.5 0 0 1-.057-.23zM16 12.667a.667.667 0 1 0 0-1.333.667.667 0 0 0 0 1.333",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M19.507 13.325c-.437.834-1.752 1.576-2.84 1.343l-.34.717a.33.33 0 0 0-.024.215l.214.969q.02.091-.01.18l-.108.316a.33.33 0 0 0 .02.262l.562 1.08q-.314.646-.98.648-.668 0-.981-.648l.563-1.08a.33.33 0 0 0 .02-.262l-.11-.316a.33.33 0 0 1-.01-.18l.215-.969a.33.33 0 0 0-.024-.215l-.34-.717c-1.088.233-2.402-.509-2.84-1.343 1.347.37 2.544-1.682 3.506-.175.963-1.507 2.16.545 3.507.175",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M12.483 14.76a3.667 3.667 0 1 0 7.034 0 4 4 0 1 1-7.034 0",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagBrn = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagBrn_default = SvgFlagBrn;

export { FlagBrn_default as default };
